import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import ClientStories from '../components/ClientStories';
import Contact from '../components/Contact';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <ClientStories />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
